import React from "react";
import { SingleNft } from "../components/SingleNft/SingleNft";

export const NftPage = () => {
  return <SingleNft />;
};
